import { Card } from "@/components/ui/card";
import beforeAfterBikes from "@/assets/before-after-bikes.jpg";
import bikeGallery from "@/assets/bike-gallery.jpg";

export const GallerySection = () => {
  const projects = [
    {
      title: "Projekt: Mroczny Rycerz",
      description: "Zwykły rower górski zyskał agresywny charakter dzięki matowej czerni i niestandardowym komponentom.",
      beforeImage: beforeAfterBikes,
      afterImage: beforeAfterBikes,
    },
    {
      title: "Projekt: Neonowy Demon",
      description: "Nudny rower szosowy został przekształcony w przyciągające wzrok dzieło sztuki z neonowymi detalami.",
      beforeImage: bikeGallery,
      afterImage: bikeGallery,
    }
  ];

  return (
    <section id="gallery" className="py-24 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-montserrat font-bold text-4xl md:text-5xl mb-6">
            Nasze <span className="text-primary">Realizacje</span>
          </h2>
          <p className="text-xl text-muted-foreground font-inter max-w-3xl mx-auto">
            Zobacz, jak przekształcamy standardowe rowery w spersonalizowane maszyny, które odzwierciedlają styl ich właścicieli.
          </p>
        </div>

        <div className="space-y-20">
          {projects.map((project, index) => (
            <div key={index} className="space-y-6">
              <div className="text-center">
                <h3 className="font-montserrat font-bold text-3xl text-foreground">{project.title}</h3>
                <p className="text-muted-foreground font-inter max-w-2xl mx-auto">{project.description}</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                {/* Before Card */}
                <div className="flex flex-col items-center">
                  <h4 className="font-montserrat font-semibold text-2xl text-muted-foreground mb-4">Przed</h4>
                  <Card className="overflow-hidden bg-card border-accent/20 w-full">
                    <img 
                      src={project.beforeImage} 
                      alt={`Rower przed transformacją - ${project.title}`}
                      className="w-full h-80 object-cover grayscale brightness-75"
                    />
                  </Card>
                </div>
                
                {/* After Card */}
                <div className="flex flex-col items-center">
                  <h4 className="font-montserrat font-semibold text-2xl text-primary mb-4">Po</h4>
                  <Card className="overflow-hidden bg-card border-primary/50 shadow-lg shadow-primary/20 w-full">
                    <img 
                      src={project.afterImage} 
                      alt={`Rower po transformacji - ${project.title}`}
                      className="w-full h-80 object-cover"
                    />
                  </Card>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-20">
          <p className="text-muted-foreground font-inter mb-6 text-lg">
            Twój rower może być następny. Masz już wizję?
          </p>
          <div className="inline-block bg-primary text-primary-foreground p-4 rounded-lg interactive-scale">
            <span className="font-montserrat font-bold text-xl">
              Skontaktuj się z nami i odmień swoją maszynę!
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
